import BannerXApp from '../sponsored/components/BannerXApp.vue';
import CatapultBannerApp from '../sponsored/components/CatapultBannerApp.vue';
import CategoryCarouselApp from './components/category-carousel/CategoryCarouselApp.vue';
import Checkbox from '../components/forms/Checkbox.vue';
import clickOutside from '../directives/click-outside';
import createApp from 'JS/dxp/app';
import FacetsApp from './components/facets/FacetsApp.vue';
import FilterHeaderApp from './components/filter-header/FilterHeaderApp.vue';
import Icon from  '../components/Icon.vue';
import ProductListApp from './components/product-list/ProductListApp.vue';
import ProductService from 'JS/services/ProductService';
import SearchBar from '../components/forms/SearchBar.vue';
import store from './store';
import UiButton from '../components/UiButton.vue';
import VisuallyHidden from  '../components/VisuallyHidden.vue';
import Vue from 'vue';
import VueMq from 'vue-mq';
import { hydrateSsrRoots } from 'JS/ssr/client-utilities';
import { keysToCamelCase } from '../helpers/functions';

Vue.component('UiButton', UiButton);
Vue.component('Checkbox', Checkbox);
Vue.component('SearchBar', SearchBar);
Vue.component('VisuallyHidden', VisuallyHidden);
Vue.component('Icon', Icon);

Vue.directive('click-outside', clickOutside);

Vue.use(VueMq, {
	breakpoints: {
		"mobile": 768,
		"tablet": 1024,
		"desktop": Infinity
	}
});

hydrateSsrRoots('dxp', (el, data) => {
	new Vue({
		extends: createApp(data),
		el,
	});
});

new Vue({
	el: "#facets-app",
	store,
	render: h => h(FacetsApp),
	created() {
		if (window && window.searchResult) {
			store.dispatch('init', { categories: window.categories, searchResult: keysToCamelCase(window.searchResult), epsilonAds: window.epsilonAds });
		}
	}
});

new Vue({
	el: "#facets-app-header",
	store,
	render: h => h(FilterHeaderApp)
});

if (window && window.searchResult) {
	new Vue({
		el: "#banner-x-app",
		store,
		render: h => h(BannerXApp)
	});

	new Vue({
		el: "#catapult-banner-app",
		store,
		render: h => h(CatapultBannerApp)
	});

	new Vue({
		el: "#product-list-app",
		store,
		render: h => h(ProductListApp),
		provide: () => ({
			productService: new ProductService()
		}),
	});

	new Vue({
		el: "#category-carousel-app",
		store,
		render: h => h(CategoryCarouselApp),
	});
}